const JournalEntries = () => {
    return (
        <>
            <h1>This is JournalEntries Page</h1>
        </>
    );
};

export default JournalEntries;
